import { render, staticRenderFns } from "./CarouselItem.vue?vue&type=template&id=4ea4a91e&scoped=true&"
import script from "./CarouselItem.vue?vue&type=script&lang=js&"
export * from "./CarouselItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea4a91e",
  null
  
)

export default component.exports